import { Base } from "@app/controllers/base";

// Connects to data-controller="store--addons"
export default class extends Base {
  static targets = ["checkbox", "total", "grandTotal"];
  static values = { basePrice: Number, saveUrl: String };

  connect() {
    this.recalculate({ skipPersist: true });
  }

  recalculate({ skipPersist = false } = {}) {
    let addonTotal = 0;
    let selectedAddonIds = [];

    this.checkboxTargets.forEach((cb) => {
      if (cb.checked) {
        addonTotal += parseInt(cb.value, 10);
        selectedAddonIds.push(cb.dataset.addonId);
      }
    });

    const total = this.basePriceValue + addonTotal;
    if (this.hasTotalTarget) this.totalTarget.textContent = this.formatIDR(addonTotal);
    if (this.hasGrandTotalTarget) {
      this.grandTotalTarget.textContent = this.formatIDR(total);
    }

    if (!skipPersist) {
      this.persistToSession(selectedAddonIds);
    }
  }

  persistToSession(addonIds) {
    if (!this.hasSaveUrlValue) return;

    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content;

    fetch(this.saveUrlValue, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken,
        Accept: "text/vnd.turbo-stream.html",
      },
      body: JSON.stringify({ add_on_ids: addonIds }),
    });
  }

  formatIDR(amount) {
    return `Rp${amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`;
  }
}
